import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Modal, ModalClose,
    ModalDialog,
    Stack,
    Typography
} from "@mui/joy";
import React from "react";
import {useTranslation} from "react-i18next";
import {useNotification} from "../../hooks/useNotification";
import {BellDot} from "lucide-react";

type EnableNotificationsDialogProps = {
    open?: boolean,
    onClose?: () => void,
}

const EnableNotificationsDialogComponent = (props: EnableNotificationsDialogProps) => {
    const {t} = useTranslation()
    const {enableNotifications} = useNotification()

    const handleEnableNotifications = () => {
        props.onClose?.()
        enableNotifications()
    }

    return <Modal open={props.open} onClose={props.onClose}>
        <ModalDialog minWidth={"sm"} variant="outlined" role="alertdialog" sx={{padding:4}}>
            <ModalClose/>
            <DialogContent sx={{textAlign: "center"}}>
                <Stack alignItems={"center"} gap={2}>
                    <BellDot style={{fontSize:95}} />
                    <Typography level={"h3"} sx={{alignItems: "center"}}>
                        {t("enableNotificationDialogTitle")}
                    </Typography>
                    {t("enableNotificationDialogDescription")}
                </Stack>

            </DialogContent>
            <DialogActions>
                <Button variant={"soft"} color="primary" onClick={handleEnableNotifications}>
                    {t("enableNotificationActionButtonLabel")}
                </Button>
            </DialogActions>
        </ModalDialog>
    </Modal>
}


export default EnableNotificationsDialogComponent